import { render, staticRenderFns } from "./Symbol.vue?vue&type=template&id=fff7ed0c&scoped=true"
import script from "./Symbol.vue?vue&type=script&lang=js"
export * from "./Symbol.vue?vue&type=script&lang=js"
import style0 from "./Symbol.vue?vue&type=style&index=0&id=fff7ed0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff7ed0c",
  null
  
)

export default component.exports